import { observer } from 'mobx-react-lite'
import { FC } from 'react'
import { PlayIcon } from '../../../__legacy__/components/core/icons'
import { useTreeState } from '../../../__legacy__/stores/Root'
import { IArpMedia } from '../../arp-registry/ArpMedia'
import { PlaybackButton } from '../primitives'

export const ArpPlabackButton: FC<{ media: IArpMedia }> = observer(({ media }) => {
  const { globalPlayer } = useTreeState()

  const handleClick = async () => {
    globalPlayer.stop()
    await globalPlayer.setArpMediaIndex(media.id, true)
    await globalPlayer.play()
  }

  return (
    <PlaybackButton.Root onClick={handleClick} css={{ position: 'absolute', top: 0, right: 0 }}>
      <PlaybackButton.Icon as={PlayIcon} />
    </PlaybackButton.Root>
  )
})
